export default {
    namespaced: true,
    state: {
        clear:null,
        // iframe 外部通过 postMessage 传入、待 ai.vue 消费的文本
        pendingMessage:null
    },
    mutations: {
       setClear(state) {
           state.clear = new Date().getTime()
       },
       setPendingMessage(state, payload) {
           state.pendingMessage = payload
       },
       clearPendingMessage(state) {
           state.pendingMessage = null
       }
    }
  };
